import { z } from 'zod';
export const DownloadPathSchema = z.enum(['region-exports', 'vendor-rates-exports']);
export const UploadPathSchema = z.enum(['region-imports', 'vendor-rates-imports']);
